export default function DateInput({ label, value, onChange, required = false, disabled = false, inputId }) {
  return (
    <>
      <label htmlFor={inputId} style={{ fontWeight: 600 }}>{label}</label>
      <input
        id={inputId}
        type="date"
        className="form-input"
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      />
    </>
  );
}
